import {ThemeContext} from 'react-native-elements';
import {useContext} from 'react';
import {HousequeTheme} from '../houseque.theme';

//TODO allow change later, preparing for dark mode in iOS
export const useTheme = (): HousequeTheme => {
  const {theme} = useContext(ThemeContext);
  return theme as HousequeTheme;
};
